import React from 'react';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import { selectBlackjackGames, selectGamesLoading } from '@/store/games/selectors';
import GamesStreamlineSection, {
  GamesStreamlineType,
} from '@/components/shared/games/GamesStreamlineSection';
import { BffGamesCategory } from '@lucky7ventures/bff-types';
import GamesSectionHeader from '@/pages/games/lobby/lobby-sections-streamlines/GamesSectionHeader';
import GamesSection from '@/pages/games/lobby/lobby-sections-streamlines/GamesSection';

const Blackjack = () => {
  const games = useSelector(selectBlackjackGames);
  const loading = useSelector(selectGamesLoading);
  const intl = useIntl();

  if (games.length === 0 && !loading) return null;

  return (
    <GamesSection>
      <GamesSectionHeader
        title={intl.formatMessage({ id: 'games.categories.blackjack' })}
        totalGames={games.length}
        categoryPath="/games/blackjack"
      />
      <GamesStreamlineSection
        type={GamesStreamlineType.Single}
        visibleGames={18}
        loading={loading}
        games={games}
        category={BffGamesCategory.Blackjack}
      />
    </GamesSection>
  );
};

export default Blackjack;
